module.exports = __webpack_public_path__ + "media/images/investors-hero-dbe8875c4991580e1bcbe950ac558e23.png";